import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useChat } from '~/composables/useChat';
import { IEnvelope } from '~/types/chat';
import { useId } from '~/composables/useUniqueId';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageMenu',
  props: {
    actions: null,
    message: null,
    timetoken: null,
    uuid: null
  },
  setup(__props: any) {

const props = __props as {
  actions?: IEnvelope['actions'];
  message: IEnvelope['message'];
  timetoken: IEnvelope['timetoken'];
  uuid?: IEnvelope['uuid'];
};



const { pubnub, deleteMessage, reportMessage } = useChat();
const isExpanded = ref(false);
const menuId = useId('menu');
const isCurrentUser = computed(
  () => !!props.uuid && props.uuid === pubnub.getUUID(),
);
const isReported = computed(() => {
  const currentUserId = pubnub.getUUID();
  if (props.actions?.reported && currentUserId) {
    return props.actions.reported.hasOwnProperty(currentUserId);
  }
  return false;
});

return { __sfc: true,props, pubnub, deleteMessage, reportMessage, isExpanded, menuId, isCurrentUser, isReported }
}

})